$(function () {
    $('a').on('click', function () {
        let href = $(this).attr("href");
        let target = $(href);

        if (target.length && href[0] === '#') {
            event.preventDefault();
            $('html, body').animate({
                scrollTop: target.offset().top
            }, 500);
        }

    })


    $('.content').on('click', function () {
        $('.popup').each(function() {
            if (parseInt($(this).css('right')) === 0) {
                $(this).addClass('hidden');
                $('.content').removeClass('hidden');
                $('.content-mask')
                    .animate({
                        opacity: 0
                    }, 300, function () {
                        $(this).css('display', 'none');
                    });
            }
        })
    })
});